module.exports = __webpack_public_path__ + "img/gal_yes.48caa367.png";